import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import { Navigate, NavLink } from 'react-router-dom'

import { selectIsLoading } from '@src/store/ducks/auth/selectors'
import { selectIsAuth } from '@src/store/ducks/app/selectors'
import style from '@src/pages/Login/Login.module.scss'
import { LoginForm } from '@src/pages/Login/LoginForm'
import { Title } from '@src/components/Title/Title'
import { Button } from '@src/components/Button/Button'
import React, { useEffect } from 'react'
import { resetAuth } from '@src/store/ducks/auth/reducer'
import { AppDispatch } from '@src/store/store'

export const Login = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isAuth = useSelector(selectIsAuth)
  const isLoading = useSelector(selectIsLoading)

  useEffect(() => () => {
    dispatch(resetAuth())
  }, [dispatch])

  if (isAuth) {
    return <Navigate to="/lk/points/" replace />
  }

  return (
    <div className={cn(style.login)}>
      <div className={style.login__body}>
        <div className={style.tabList}>
          <NavLink end className={style.btnSize} to="/lk/login">
            <Button className={cn(style.active)}>Авторизация</Button>
          </NavLink>
          {/* <NavLink end className={style.btnSize} to="/lk/registration"> */}
          {/*  <Button>Регистрация</Button> */}
          {/* </NavLink> */}
          <NavLink end className={style.btnSize} to="/lk/activation">
            <Button>Регистрация</Button>
          </NavLink>
        </div>
        <div>
          <Title greenTitle="Войти" title="в личный кабинет" />
        </div>
        <div>
          <LoginForm isLoading={isLoading} />
        </div>
      </div>
    </div>
  )
}
